/*@flow*/
export default {
  activeModal: 'mode.activeModal',
  areaPolygonGeoJSON: 'modeAreaPolygonGeojson',
  areaPolygonModeType: 'modeAreaPolygonType',
  drawHandler: 'modeAreaPolygonDrawHandler',
  toasterStatus: 'ui.toaster.type',
  toasterMessage: 'ui.toaster.message',
  hideRightSidebar: 'mode.hideRightSidebar',
  activePanelName: 'LeftToolbar.activePanelName',
  projectRefetchHash: 'projectRefetchHash',
};
